<div class="mt-4 flex items-center gap-1">
  <soft-checkbox [value]="false" (valueChange)="selectedContact = undefined" #checkbox>
  </soft-checkbox>
  <span class="text-sm">
    {{ '#TICKETS.DIALOGS.ASSIGN_TICKET.ASSIGN' | translate }}
  </span>
</div>
@if (checkbox.value) {
  <div class="flex flex-col mt-4">
    <soft-input
      [(ngModel)]="filter"
      placeholder="{{ '#TICKETS.DIALOGS.EDIT_CONTACT.FILTER' | translate }}"
    />
    <div class="soft-list tableFixHead">
      @for (contact of filteredContacts$ | async; track contact) {
        <div
          class="soft-list-item pointer no-select hover:bg-hover rounded"
          [class.selected]="contact === selectedContact"
          (click)="selectedContact = contact"
        >
          <div class="flex flex-col pl-1">
            <span
              ><strong>{{ contact.lastName }} {{ contact.firstName }}</strong></span
            >
            <div>
              @if (contact.email1) {
                <div>
                  <span class="soft-label left">{{
                    '#TICKETS.DIALOGS.EDIT_CONTACT.EMAIL1' | translate
                  }}</span>
                  {{ contact.email1 }}
                </div>
              }
              @if (contact.email2) {
                <div>
                  <span class="soft-label left">{{
                    '#TICKETS.DIALOGS.EDIT_CONTACT.EMAIL2' | translate
                  }}</span>
                  {{ contact.email2 }}
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
<div class="flex flex-row justify-end mt-2">
  <button
    class="soft-button primary rounded hover:cursor-pointer"
    [disabled]="!checkbox.value || !selectedContact"
    (click)="onSubmit(selectedContact)"
  >
    {{
      (checkbox.value
        ? '#TICKETS.DIALOGS.ASSIGN_TICKET.ASSIGN_SUBMIT'
        : '#TICKETS.DIALOGS.ASSIGN_TICKET.TAKE_OVER_SUBMIT'
      ) | translate
    }}
  </button>
</div>
